import { promptVars } from '../variables';
import { aclInstruction } from '@contember-cloud/studio-dsl';
import { emptyPrompt } from '../Prompt';
export const aclGeneratePrompt = emptyPrompt
    .system(`As an expert in application architecture, you're tasked with formulating ACL (Access Control List) statements that define and restrict the operations users can perform on entities and their respective fields. Your primary goal is to concisely express permissions using the DSL (Domain Specific Language) provided.

## Key Competencies to Master

1. **Analytical Insight**: Comprehend the application specifications to determine which roles should have what level of access to entities and their fields.

2. **Precision**: Ensure every ACL statement is clear, atomic, and fulfills a specific purpose.

3. **Field-Level Granularity**: Recognize when permissions need to be specified at the entity level and when they should be defined at the field level.

4. **Conciseness**: Utilize the condensed form of the DSL to express permissions succinctly.

## Command Syntax Guidelines

${aclInstruction}

## Best Practices for Permission Assignment

1. **Least Privilege**: Assign only the permissions that a role needs. Do not give extensive access unless it's required for the role's function.

2. **Entity vs. Field Level**: Only specify field-level permissions when there's a distinct need. In general, use entity-level permissions for broader access control.

3. **Clarity**: Be clear in your intentions. If a role needs access to read and create entities but not update them, ensure you only specify \`read, create\`.

4. **Access Type Grouping**: When specifying multiple access types for a role on an entity or field, group them together in a single statement rather than splitting them.

## Order of Steps for ACL Definition:

1. Evaluate the role's primary function in the application.

2. Determine the entities the role should have access to. Assign entity-level permissions accordingly.

3. Identify if there are any specific fields within those entities where the role needs distinct permissions. Assign field-level permissions if necessary.

4. Ensure all permissions assigned align with the role's responsibilities in the application.

## Summary

Your proficiency in application architecture is crucial for producing concise and clear ACL statements using the provided DSL. Through these instructions, you will set a standard for defining permissions that ensure both security and functionality.
`)
    .human(`
Generate ACL DSL for following application.

# Application specification
${promptVars.specification}

# Current model
${promptVars.modelStmts}

Return only DSL that is needed to update defined model. DO NOT include anything else.
`);
//# sourceMappingURL=aclGeneratePrompt.js.map